import Button from '../../common/Button/Button.component'
import React from 'react'
import { fireEvent } from '../../../cra'
import styled from '@emotion/styled'
import theme from '../../../global/theme'

interface ModelProps {
  onConfirm: () => void
  onReject: () => void
}

const Container = styled.div`
  min-height: 150px;

  h3 {
    color: #272f69;
    padding-top: 0px;
    padding-bottom: 30px;
  }
  p {
    margin-bottom: 16px;
    font-weight: 600;
    font-size: 14px;
    color: ${theme.colors.textDark};
  }

  div {
    display: flex;
    justify-content: space-between;
  }

  @media screen and (max-width: 750px) {
    div {
      flex-direction: column;
      justify-content: center;
      align-items: center;
    }
  }
`
const ModalButton = styled.div`
  width: 150px;
  text-decoration: none;

  @media screen and (max-width: 750px) {
    width: 100%;
  }
`

const EffectiveDateFilterChangeConfirmation: React.FC<ModelProps> = ({
  onConfirm,
  onReject,
}) => {
  return (
    <Container>
      <h3>Are you sure you want update the effective date filter?</h3>
      <p>Click “Yes” to confirm and refresh your quotes!</p>
      <div>
        <ModalButton>
          <Button
            variant='contained'
            bold={false}
            width='100%'
            color='secondary'
            onClick={(e) => {
              fireEvent('confirmEffectiveDateFilterChange', e, {
                description: `Confirmed Effective Date Filter Change`,
              })
              onConfirm()
            }}
            fontSize='14px'
            description={`Confirmed Effective Date Filter Change`}
          >
            Yes
          </Button>
        </ModalButton>

        <ModalButton>
          <Button
            color='info'
            bold={false}
            width='100%'
            onClick={(e) => {
              fireEvent('rejectEffectiveDateFilterChange', e, {
                description: `Rejected Effective Date Filter Change`,
              })
              onReject()
            }}
            fontSize='14px'
            description={`Cancelled Effective Date Filter Change`}
          >
            No
          </Button>
        </ModalButton>
      </div>
    </Container>
  )
}

export default EffectiveDateFilterChangeConfirmation
